module.exports = __webpack_public_path__ + "img/team.9d572dc8.png";